/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_CustomerPreferencesDTO } from '../models/Routemize_DTOs_CustomerPreferencesDTO';
import type { Routemize_DTOs_UpdateCustomerPreferencesDTO } from '../models/Routemize_DTOs_UpdateCustomerPreferencesDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerPreferencesService {
    /**
     * @returns Routemize_DTOs_CustomerPreferencesDTO OK
     * @throws ApiError
     */
    public static getApiAppCustomerPreferencesGet(): CancelablePromise<Routemize_DTOs_CustomerPreferencesDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/customerPreferences/get',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_CustomerPreferencesDTO OK
     * @throws ApiError
     */
    public static postApiAppCustomerPreferencesCreate(
        requestBody?: Routemize_DTOs_CustomerPreferencesDTO,
    ): CancelablePromise<Routemize_DTOs_CustomerPreferencesDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/customerPreferences/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_CustomerPreferencesDTO OK
     * @throws ApiError
     */
    public static putApiAppCustomerPreferencesUpdate(
        requestBody?: Routemize_DTOs_UpdateCustomerPreferencesDTO,
    ): CancelablePromise<Routemize_DTOs_CustomerPreferencesDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/customerPreferences/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
